import type { AdHocAggregateResult, AnalyticsField, AnalyticsMetric } from '@/shared/analytics/AnalyticsTypes';
import { formatMetricValue, formatPercent, metricLabel, humanUser } from '@/shared/analytics/MetricFormatting';

/**
 * Builds a short, data-grounded takeaway from an aggregate result, appended to
 * the model's framing narrative so the answer reflects the live numbers (the
 * model never sees the data). Mirrors the spirit of {@link deriveCallouts}.
 */
export function buildAssistNarrative(result: AdHocAggregateResult, field: AnalyticsField, metric: AnalyticsMetric): string {
    const total = result.totals[metric];
    const first = result.rows[0];
    if (first === undefined || total === 0) {
        return 'No matching activity in the current view.';
    }
    const raw = first.keys[field] ?? '—';
    const label = field === 'user_id' ? humanUser(raw) : raw;
    const share = first.metrics[metric] / total;
    return `${label} leads on ${metricLabel(metric).toLowerCase()} (${formatMetricValue(metric, first.metrics[metric])}, ${formatPercent(share)} of ${result.distinctCount}).`;
}
